import useConfiguration from './useConfiguration';

/**
 * @example const { themeMode, onThemeModeChange } = useThemeMode();
 * @returns Object containing themeMode and onThemeModeChange function.
 */
const useThemeMode = () => {
  const { themeMode, onThemeModeChange } = useConfiguration();
  return { themeMode, onThemeModeChange };
};

export default useThemeMode;
